(function() {
  'use strict';
  
  // Initialize collection product image sliders (similar to best-seller)
  function initCollectionProductSliders() {
    var productItems = document.querySelectorAll('.collection-product-item');
    
    if (productItems.length === 0) {
      return; // No items found yet
    }
    
    productItems.forEach(function(item) {
      if (item.hasAttribute('data-image-slider-init')) return;
      
      var sliderImages = item.querySelectorAll('.collection-product-slider-image');
      
      // Skip if no slider images found (might be single image or not loaded yet)
      if (sliderImages.length === 0) {
        return;
      }
      
      item.setAttribute('data-image-slider-init', 'true');

      // Find buttons - they're inside the image-slider container
      var imageSlider = item.querySelector('.collection-product-image-slider');
      var prevBtn = imageSlider ? imageSlider.querySelector('.collection-product-slider-nav.prev') : null;
      var nextBtn = imageSlider ? imageSlider.querySelector('.collection-product-slider-nav.next') : null;
      
      // Find current active image index
      var currentIndex = 0;
      sliderImages.forEach(function(img, i) {
        if (img.classList.contains('active')) {
          currentIndex = i;
        }
      });

      if (sliderImages.length <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      // Ensure first image is active if none are
      if (!sliderImages[currentIndex] || !sliderImages[currentIndex].classList.contains('active')) {
        sliderImages.forEach(function(img, i) {
          img.classList.remove('active');
        });
        if (sliderImages[0]) {
          sliderImages[0].classList.add('active');
        }
        currentIndex = 0;
      }

      function showImage(index) {
        sliderImages.forEach(function(img, i) {
          img.classList.remove('active');
          if (i === index) {
            img.classList.add('active');
          }
        });
      }

      function nextImage(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        currentIndex = (currentIndex + 1) % sliderImages.length;
        showImage(currentIndex);
      }

      function prevImage(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        currentIndex = (currentIndex - 1 + sliderImages.length) % sliderImages.length;
        showImage(currentIndex);
      }

      // Clone buttons to avoid duplicate event listeners (like best-seller does)
      if (nextBtn && nextBtn.parentNode) {
        var newNext = nextBtn.cloneNode(true);
        nextBtn.parentNode.replaceChild(newNext, nextBtn);
        newNext.addEventListener('click', nextImage);
      }

      if (prevBtn && prevBtn.parentNode) {
        var newPrev = prevBtn.cloneNode(true);
        prevBtn.parentNode.replaceChild(newPrev, prevBtn);
        newPrev.addEventListener('click', prevImage);
      }

       // Reset to first image whenever the user stops hovering the product card,
      // so the next hover always starts from the main image.
      item.addEventListener('mouseleave', function() {
        if (sliderImages.length > 0) {
          currentIndex = 0;
          showImage(currentIndex);
        }
      });
      
    });
  }

  // Initialize ProductItems for add to cart
  function initCollectionProductItems() {
    if (typeof window.Theme !== 'undefined' && window.Theme.ProductItem) {
      var productEls = document.querySelectorAll('.collection-product-item[data-product-item]');
      productEls.forEach(function(item) {
        if (!item.hasAttribute('data-product-item-initialized')) {
          try {
            new window.Theme.ProductItem(item);
            item.setAttribute('data-product-item-initialized', 'true');
          } catch(e) {
            console.error('Error initializing ProductItem:', e);
          }
        }
      });
    }
  }

  // Main initialization function
  function initCollectionSection() {
    initCollectionProductItems();
    // Multiple attempts to ensure sliders are initialized
    setTimeout(function() {
      initCollectionProductSliders();
    }, 100);
    setTimeout(function() {
      initCollectionProductSliders();
    }, 500);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCollectionSection();
    });
  } else {
    initCollectionSection();
  }

  // Also initialize on window load
  window.addEventListener('load', function() {
    setTimeout(function() {
      initCollectionProductSliders();
    }, 300);
  });

  // Re-initialize when collection updates (for AJAX filtering)
  var collectionObserver = null;
  function setupCollectionObserver() {
    var collectionElement = document.querySelector('.collection') || document.getElementById('product-grid');
    if (collectionElement && !collectionObserver) {
      collectionObserver = new MutationObserver(function(mutations) {
        var shouldReinit = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (!collectionElement.classList.contains('loading')) {
              shouldReinit = true;
            }
          } else if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if new collection product items were added
            for (var i = 0; i < mutation.addedNodes.length; i++) {
              var node = mutation.addedNodes[i];
              if (node.nodeType === 1) {
                if (node.classList && node.classList.contains('collection-product-item')) {
                  shouldReinit = true;
                  break;
                } else if (node.querySelectorAll && node.querySelectorAll('.collection-product-item').length > 0) {
                  shouldReinit = true;
                  break;
                }
              }
            }
          }
        });
        
        if (shouldReinit) {
          // Reset initialization flags for new items
          var newItems = collectionElement.querySelectorAll('.collection-product-item:not([data-image-slider-init])');
          setTimeout(function() {
            initCollectionSection();
          }, 300);
        }
      });
      
      collectionObserver.observe(collectionElement, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true
      });
    } else if (!collectionElement) {
      setTimeout(setupCollectionObserver, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCollectionObserver);
  } else {
    setupCollectionObserver();
  }

  // Initialize in Shopify editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target && (event.target.id === 'ProductGridContainer' || event.target.querySelector('.collection'))) {
      setTimeout(initCollectionSection, 300);
    }
  });

  // Watch for dynamically added collection product items
  if (typeof MutationObserver !== 'undefined') {
    var productGridObserver = new MutationObserver(function(mutations) {
      var hasNewItems = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.nodeType === 1) {
              if (node.classList && node.classList.contains('collection-product-item')) {
                hasNewItems = true;
                break;
              } else if (node.querySelectorAll && node.querySelectorAll('.collection-product-item').length > 0) {
                hasNewItems = true;
                break;
              }
            }
          }
        }
      });
      
      if (hasNewItems) {
        setTimeout(function() {
          initCollectionProductSliders();
        }, 300);
      }
    });
    
    function startProductGridObserver() {
      var target = document.getElementById('product-grid') || 
                   document.getElementById('ProductGridContainer') || 
                   document.querySelector('.collection') ||
                   document.body;
      if (target) {
        productGridObserver.observe(target, {
          childList: true,
          subtree: true
        });
      } else {
        setTimeout(startProductGridObserver, 500);
      }
    }
    
    if (document.body) {
      startProductGridObserver();
    } else {
      document.addEventListener('DOMContentLoaded', startProductGridObserver);
    }
  }

  // Expose for manual calls
  window.initCollectionProductSliders = initCollectionProductSliders;
  window.initCollectionSection = initCollectionSection;
})();
